import React from "react";
import CommonDefaultQuestionEdit from "./CommonDefaultQuestionEdit";

function QuestionSingleChoiceEdit(props) {

   return (<CommonDefaultQuestionEdit {...props}/>);
}

export default QuestionSingleChoiceEdit;